import { useContext } from "react";
import ArchiveSchedulerContext from "./ArchiveSchedulerContext";

const useArchiveScheduler = () => {
    return useContext(ArchiveSchedulerContext);
}

export default useArchiveScheduler;